import type { Analytics } from './types';

/**
 * Dev-friendly analytics sink. Logs every call to the console with a
 * `[analytics]` prefix so engineers can verify event firing without setting
 * up a real backend. Production builds typically swap this for
 * `createPostHogAnalytics()` (or a no-op).
 */
export function createConsoleAnalytics(): Analytics {
  return {
    track(event, properties) {
      console.info('[analytics] track', event, properties ?? {});
    },
    identify(user) {
      console.info('[analytics] identify', user);
    },
    page(path, properties) {
      console.info('[analytics] page', path ?? location.pathname, properties ?? {});
    },
    flush() {
      // No-op: console writes synchronously.
    },
  };
}

/**
 * Black-hole adapter for environments where analytics are not configured
 * (e.g. self-hosted setups without a key). Cheap, easy to reason about,
 * and keeps consumers free of conditionals.
 */
export function createNoopAnalytics(): Analytics {
  const noop = (): void => undefined;
  return { track: noop, identify: noop, page: noop, flush: noop };
}
